import { Injector } from '@angular/core';

export class GlobalInjector {
  private static injector: Injector;

  static setInjector(injector: Injector) {
    this.injector = injector;
  }

  static get<T>(token: any): T {
    if (!this.injector) {
      throw new Error('Injector has not been set!');
    }
    return this.injector.get<T>(token);
  }
}